import React from "react";
import { colors } from "../../constants/colors";
import { Form, Input, Button } from 'antd';
import serviceMail from '../../services/sendmail'
import cartoonMap from "../../images/cartoonMap.svg";
import { toast } from "react-toastify";
import { emailTemplate } from '../../helper/emailTemplate'

export const ContactForm = () => {
  const [form] = Form.useForm();

  function handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message,
    };
    serviceMail.sendMail(data);
  }

  function handleSubmit(values) {
    const { email, name, introduction } = values
    const subject = `${name} Want to connect GenC Health`;
    // const content = `
    // <div>Name: ${name}</div>
    // <div Email: ${email}</div>
    // <div>Message: ${introduction || ''}</div>
    // <div>The Genc team</div>
    // <a href="https://www.genchealth.com/" tagert="_blank">https://www.genchealth.com/</a>
    // `;
    const content = emailTemplate({ email, name, introduction, subject })
    toast.success(("Your request send successfully"))

    handleSendMail(subject, content, email, ['philiptranp@gmail.com', 'support@angelo.network', 'cuongseven789@gmail.com'])

    form.resetFields()
  }

  return (
    <section
      className="contact-us-form container-fluid text-center p-5"
      id="contact-us-form"
      data-aos="fade-down"
      style={{ backgroundColor: colors.gencWhite }}
    >
      <h1 style={{ color: colors.gencBlue }}>Live Demo and Inquiries</h1>
      <div className="row justify-content-center">
        <div className="contact-us-details text-left col-xs-12 col-sm-6 p-5">
          <p>
          For inquiries or to request a live demo with one of our GenC Labs and Hybrid Blockchain experts
and to valuate the benefits when adopting the hybrid blockchain technology, please use the contact form.
          </p>
          <img src={cartoonMap} alt="Cartoon Map" />
        </div>
        <div className="contact-us-form-submit text-left d-flex flex-column col-xs-12 col-sm-6 p-5">
          <Form form={form} layout="vertical" onFinish={(values) => { handleSubmit(values) }} >
            <Form.Item name={'name'} label="Your name" rules={[{ required: true, message: 'Your name is require' }]}>
              <Input />
            </Form.Item>
            <Form.Item name={'email'} label="Your email" rules={[{ required: true, type: 'email', message: 'Your email is invalid' }]}>
              <Input />
            </Form.Item>

            <Form.Item name={'introduction'} label="Your message">
              <Input.TextArea rows={6} />
            </Form.Item>
            <Form.Item >
              <Button className="sendButton" type="primary" htmlType="submit">
                Send
              </Button>
            </Form.Item>
          </Form>

        </div>
      </div>
    </section>
  );
};
